import { getOperationsGroup } from "../../../../actions/Utilities/Common";
import { useQuery } from "react-query";

export default function useGetOperationsGroup() {
  return useQuery(
    "GetOperationsGroup",
    getOperationsGroup,
    {
      refetchOnWindowFocus: false,
    }
  );
}
